var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-window',{model:{value:(_vm.step),callback:function ($$v) {_vm.step=$$v},expression:"step"}},[_c('v-window-item',{attrs:{"value":1}},[_c('testate',{on:{"apriDettaglio":_vm.apriDettaglio}})],1),_c('v-window-item',{attrs:{"value":2}},[_c('dettaglio',{attrs:{"chiaveMovimento":_vm.chiaveMovimento},on:{"back":_vm.tornaIndietro}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }